import { ApplicationLaunchRequest, ApplicationsLaunchRequest } from "../../../../domain/localhost/items";
import { IApplicationLaunchRequestBean, IApplicationsLaunchRequestBean } from "../beans";

export class ApplicationLaunchRequestTranslator {
  static toApplicationLaunchRequestBean(request: ApplicationLaunchRequest): IApplicationLaunchRequestBean {
    if (!request) { return null; }
    return {
      modulePath: request.modulePath,
      argumentsText: request.argumentsText,
    };
  }

  static toApplicationsLaunchRequestBean(request: ApplicationsLaunchRequest): IApplicationsLaunchRequestBean {
    if (!request) { return null; }
    return {
      requests: request.requests.map(r => this.toApplicationLaunchRequestBean(r)),
    };
  }
}
